export const THEMES = [
  {
    id: 'classic',
    name: 'Classic Ledger',
    description: 'Professional navy & gold',
    sidebar: {
      bg: '#0F2542',
      text: '#ffffff',
      textMuted: 'rgba(255,255,255,0.5)',
      accent: '#F0A500',
      navActiveBg: 'rgba(240,165,0,0.15)',
      navActiveBorder: '#F0A500',
      sectionLabel: 'rgba(255,255,255,0.35)',
      logoBg: '#F0A500',
      logoColor: '#0F2542',
      userAvBg: '#F0A500',
      userAvColor: '#0F2542',
      border: 'rgba(255,255,255,0.1)',
      subMenuBg: '#071C38',
      hoverBg: 'rgba(255,255,255,0.06)',
    },
    main: {
      bg: '#F7F8FC',
      topbarBg: '#0F2542',
      topbarBorder: '#1a3558',
      topbarText: '#ffffff',
      titleColor: '#0F2542',
      cardBg: '#ffffff',
      cardBorder: '#E8ECF4',
      accent: '#F0A500',
      btnBg: '#0F2542',
      btnColor: '#ffffff',
      textPrimary: '#0F2542',
      textSecondary: '#374151',
      textMuted: '#94A3B8',
      tableHeadBg: '#F7F8FC',
      rowHover: '#FAFBFF',
    },
  },
  {
    id: 'midnight',
    name: 'Midnight Velocity',
    description: 'Dark with purple accents',
    sidebar: {
      bg: '#0D0D1F',
      text: '#E2E8F0',
      textMuted: 'rgba(226,232,240,0.45)',
      accent: '#A78BFA',
      navActiveBg: 'rgba(167,139,250,0.15)',
      navActiveBorder: '#A78BFA',
      sectionLabel: 'rgba(226,232,240,0.3)',
      logoBg: '#A78BFA',
      logoColor: '#0D0D1F',
      userAvBg: '#A78BFA',
      userAvColor: '#0D0D1F',
      border: 'rgba(167,139,250,0.15)',
      subMenuBg: '#07071A',
      hoverBg: 'rgba(255,255,255,0.05)',
    },
    main: {
      bg: '#080818',
      topbarBg: '#0D0D1F',
      topbarBorder: '#1A1A35',
      topbarText: '#E2E8F0',
      titleColor: '#E2E8F0',
      cardBg: '#13132A',
      cardBorder: '#1E1E3F',
      accent: '#A78BFA',
      btnBg: '#A78BFA',
      btnColor: '#0D0D1F',
      textPrimary: '#E2E8F0',
      textSecondary: '#CBD5E1',
      textMuted: '#64748B',
      tableHeadBg: '#0D0D24',
      rowHover: '#1A1A38',
    },
  },
  {
    id: 'golden',
    name: 'Golden Era',
    description: 'Warm amber & brown tones',
    sidebar: {
      bg: '#1C1406',
      text: '#FEF3C7',
      textMuted: 'rgba(254,243,199,0.5)',
      accent: '#F59E0B',
      navActiveBg: 'rgba(245,158,11,0.18)',
      navActiveBorder: '#F59E0B',
      sectionLabel: 'rgba(254,243,199,0.35)',
      logoBg: '#F59E0B',
      logoColor: '#1C1406',
      userAvBg: '#F59E0B',
      userAvColor: '#1C1406',
      border: 'rgba(245,158,11,0.2)',
      subMenuBg: '#110D04',
      hoverBg: 'rgba(245,158,11,0.08)',
    },
    main: {
      bg: '#FFFDF5',
      topbarBg: '#1C1406',
      topbarBorder: '#2D1E06',
      topbarText: '#FEF3C7',
      titleColor: '#78350F',
      cardBg: '#ffffff',
      cardBorder: '#FDE68A',
      accent: '#F59E0B',
      btnBg: '#92400E',
      btnColor: '#ffffff',
      textPrimary: '#78350F',
      textSecondary: '#92400E',
      textMuted: '#A16207',
      tableHeadBg: '#FFFBEB',
      rowHover: '#FFFDF5',
    },
  },
  {
    id: 'sapphire',
    name: 'Sapphire Pro',
    description: 'Deep blue professional',
    sidebar: {
      bg: '#1E3A8A',
      text: '#EFF6FF',
      textMuted: 'rgba(239,246,255,0.5)',
      accent: '#38BDF8',
      navActiveBg: 'rgba(56,189,248,0.15)',
      navActiveBorder: '#38BDF8',
      sectionLabel: 'rgba(239,246,255,0.35)',
      logoBg: '#38BDF8',
      logoColor: '#1E3A8A',
      userAvBg: '#38BDF8',
      userAvColor: '#1E3A8A',
      border: 'rgba(56,189,248,0.2)',
      subMenuBg: '#172D6E',
      hoverBg: 'rgba(255,255,255,0.08)',
    },
    main: {
      bg: '#F0F7FF',
      topbarBg: '#1E3A8A',
      topbarBorder: '#1e3a8a',
      topbarText: '#EFF6FF',
      titleColor: '#1E3A8A',
      cardBg: '#ffffff',
      cardBorder: '#BFDBFE',
      accent: '#2563EB',
      btnBg: '#1E3A8A',
      btnColor: '#ffffff',
      textPrimary: '#1E3A8A',
      textSecondary: '#1D4ED8',
      textMuted: '#93C5FD',
      tableHeadBg: '#EFF6FF',
      rowHover: '#F0F7FF',
    },
  },
  {
    id: 'emerald',
    name: 'Emerald Grove',
    description: 'Forest green & nature',
    sidebar: {
      bg: '#064E3B',
      text: '#ECFDF5',
      textMuted: 'rgba(236,253,245,0.5)',
      accent: '#34D399',
      navActiveBg: 'rgba(52,211,153,0.15)',
      navActiveBorder: '#34D399',
      sectionLabel: 'rgba(236,253,245,0.35)',
      logoBg: '#34D399',
      logoColor: '#064E3B',
      userAvBg: '#34D399',
      userAvColor: '#064E3B',
      border: 'rgba(52,211,153,0.2)',
      subMenuBg: '#022C22',
      hoverBg: 'rgba(52,211,153,0.08)',
    },
    main: {
      bg: '#F0FDF8',
      topbarBg: '#064E3B',
      topbarBorder: '#065F46',
      topbarText: '#ECFDF5',
      titleColor: '#064E3B',
      cardBg: '#ffffff',
      cardBorder: '#A7F3D0',
      accent: '#059669',
      btnBg: '#064E3B',
      btnColor: '#ffffff',
      textPrimary: '#064E3B',
      textSecondary: '#065F46',
      textMuted: '#6EE7B7',
      tableHeadBg: '#F0FDF4',
      rowHover: '#F0FDF8',
    },
  },
  {
    id: 'rose',
    name: 'Rose Executive',
    description: 'Dark rose & executive',
    sidebar: {
      bg: '#1F1235',
      text: '#FFF1F2',
      textMuted: 'rgba(255,241,242,0.5)',
      accent: '#FB7185',
      navActiveBg: 'rgba(251,113,133,0.15)',
      navActiveBorder: '#FB7185',
      sectionLabel: 'rgba(255,241,242,0.35)',
      logoBg: '#FB7185',
      logoColor: '#1F1235',
      userAvBg: '#FB7185',
      userAvColor: '#1F1235',
      border: 'rgba(251,113,133,0.2)',
      subMenuBg: '#130A24',
      hoverBg: 'rgba(251,113,133,0.08)',
    },
    main: {
      bg: '#FFF1F3',
      topbarBg: '#1F1235',
      topbarBorder: '#2D1A4A',
      topbarText: '#FFF1F2',
      titleColor: '#881337',
      cardBg: '#ffffff',
      cardBorder: '#FFE4E6',
      accent: '#E11D48',
      btnBg: '#881337',
      btnColor: '#ffffff',
      textPrimary: '#881337',
      textSecondary: '#9F1239',
      textMuted: '#FDA4AF',
      tableHeadBg: '#FFF1F2',
      rowHover: '#FFF1F3',
    },
  },
  {
    id: 'cupertino',
    name: 'Cupertino',
    description: 'Apple-inspired · white, calm, fast',
    sidebar: {
      bg: '#FBFBFD',
      text: '#1D1D1F',
      textMuted: '#86868B',
      accent: '#B8860B',
      navActiveBg: '#EDEDF0',
      navActiveBorder: 'transparent',
      sectionLabel: '#86868B',
      logoBg: 'transparent',
      logoColor: '#1D1D1F',
      userAvBg: '#1D1D1F',
      userAvColor: '#ffffff',
      border: '#F0F0F2',
      subMenuBg: '#F5F5F7',
      hoverBg: '#F5F5F7',
    },
    main: {
      bg: '#FBFBFD',
      topbarBg: '#FBFBFD',
      topbarBorder: '#F0F0F2',
      topbarText: '#1D1D1F',
      titleColor: '#1D1D1F',
      cardBg: '#FFFFFF',
      cardBorder: '#F0F0F2',
      accent: '#B8860B',
      btnBg: '#1D1D1F',
      btnColor: '#ffffff',
      textPrimary: '#1D1D1F',
      textSecondary: '#374151',
      textMuted: '#86868B',
      tableHeadBg: 'transparent',
      rowHover: '#F5F5F7',
    },
    cssVars: {
      '--surface': '#FFFFFF',
      '--surface-hover': '#F5F5F7',
      '--ink': '#1D1D1F',
      '--gray': '#86868B',
      '--gray-light': '#C7C7CC',
      '--hairline': '#F0F0F2',
      '--c-red': '#E8434C',
      '--c-amber': '#C77D00',
      '--c-green': '#2E7D32',
      '--radius': '14px',
      '--radius-lg': '18px',
    },
  },
];

export const DEFAULT_THEME_ID = 'cupertino';
